// extracted by mini-css-extract-plugin
export default {"container":"about_container__RDBdB","box_container":"about_box_container__CAQzL","text_box":"about_text_box__y26pM"};